import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
  CircularProgress,
} from '@mui/material';
import {
  CheckCircle,
  Error,
} from '@mui/icons-material';
import { wolvesLabsColors } from '../../theme/wolvesLabsTheme';

interface ContactModalProps {
  open: boolean;
  type: 'loading' | 'success' | 'error';
  title: string;
  message: string;
}

const ContactModal: React.FC<ContactModalProps> = ({ open, type, title, message }) => {
  const getIcon = () => {
    switch (type) {
      case 'loading':
        return (
          <CircularProgress 
            size={60} 
            sx={{ 
              color: wolvesLabsColors.accent,
              mb: 2 
            }} 
          />
        );
      case 'success':
        return (
          <CheckCircle 
            sx={{ 
              fontSize: 60, 
              color: '#4caf50',
              mb: 2 
            }} 
          />
        );
      case 'error':
        return (
          <Error 
            sx={{ 
              fontSize: 60, 
              color: '#f44336',
              mb: 2 
            }} 
          />
        );
      default:
        return null;
    }
  };

  const getBackgroundColor = () => {
    switch (type) {
      case 'loading':
        return 'rgba(49, 130, 206, 0.1)';
      case 'success':
        return 'rgba(76, 175, 80, 0.1)';
      case 'error':
        return 'rgba(244, 67, 54, 0.1)';
      default:
        return 'rgba(255, 255, 255, 0.1)';
    }
  };

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 0,
          backgroundColor: 'white',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
        },
      }}
    >
      <DialogContent sx={{ p: 4, textAlign: 'center' }}>
        <Box
          sx={{
            p: 3,
            borderRadius: 0,
            backgroundColor: getBackgroundColor(),
            mb: 3,
          }}
        >
          {getIcon()}
        </Box>
        
        <DialogTitle
          sx={{
            fontSize: '1.5rem',
            fontWeight: 700,
            color: wolvesLabsColors.primary,
            mb: 2,
            p: 0,
          }}
        >
          {title}
        </DialogTitle>
        
        <Typography
          variant="body1"
          sx={{
            color: wolvesLabsColors.gray[600],
            lineHeight: 1.6,
            mb: 3,
          }}
        >
          {message}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default ContactModal;
